var exports = {
  "q": "x127c5a35--099e51--price",
  "A": "x127c5a35--099e51--price--booked",
};

module.exports = exports;
